import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter, Link } from "react-router-dom";
import { Buttons, Alert, Heading, ArrowLink, Text, GridWrapper, Button, Input, GridRow, GridColumn } from 'react-onei';

import Spinner from '../../Spinner/Spinner';
import LetterConfirm from './LetterConfirm';
import PendingLetter from './PendingLetter';
import ApiService from '../../../services/ApiService';
import TagService from '../../../services/TagService';
import { events } from '../../../conf/tags_ga.conf';
import UserContext from '../../../context/UserContext';

export class LetterView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postalCode: '',
      error: undefined,
      isFetching: false,
      isCheckingEligibility: true,
      letterIsSent: false,
      letterIsPending: false,
      isSubmitted: false,
    };

    this.postalInput = React.createRef();
  }

  componentDidMount() {
    this.checkPendingLetter();
  }

  checkPendingLetter = async () => {
    const { history } = this.props;
    const { wording, setStep } = this.context;
    const { WLOST_234, WLOST_235 } = wording;

    try {
      const res = await ApiService.checkPendingLetter();

      if (res.data.data.letter) {
        setStep('/letter/pending');
        history.push('/letter/pending');
      }
    } catch (err) {
      const code = err.response?.data?.code;
      switch (code) {
        case 403202:
          history.push({
            pathname: '/error',
            state: {
              title: WLOST_234,
              message: WLOST_235,
            },
          });
          break;
        default:
          history.push({
            pathname: '/error',
            state: {
              code
            }
          });
          break;
      }
    }
    this.setState({ isCheckingEligibility: false });
  }

  /**
   * Change postalCode state on change
   * Clear any error when exists on change
   * @param e
   */
  handleChange = (e) => {
    const { value } = e.target;

    this.setState({
      postalCode: value.trim(),
      error: undefined,
      isSubmitted: false,
    });
  };

  /**
   * Set empty error on input blur
   */
  handleBlur = (e) => {
    const { postalCode } = this.state;
    const { wording } = this.context;
    const { WLOST_232 } = wording;

    if (e.relatedTarget && (e.relatedTarget.tagName === "A")) {
      return
    } else if (!postalCode) {
      this.setState({ error: WLOST_232 });
    }
  };

  sendLetter = async () => {
    const { postalCode } = this.state;
    const { history } = this.props;
    const { wording, setStep } = this.context;
    const { WLOST_232, WLOST_233, WLOST_234, WLOST_235 } = wording;

    try {
      await ApiService.sendLetter({ postalCode });
      setStep('/letter/confirm');
      history.push('/letter/confirm');
    } catch (err) {
      const code = err.response?.data?.code;
      switch (code) {
        case 403201:
          setStep('/letter/pending');
          history.push('/letter/pending');
          break;
        case 412002:
          this.setState({ error: WLOST_232 });
          break;
        case 412004:
        case 412201:
          this.setState({ error: WLOST_233 });
          break;
        case 403202:
          history.push({
            pathname: '/error',
            state: {
              title: WLOST_234,
              message: WLOST_235,
            },
          });
          break;
        default:
          history.push({
            pathname: '/error',
            state: {
              code,
            }
          });
          break;
      }
    }
    this.setState({ isFetching: false });
  }

  /**
   * Send letter on submit
   * @param e
   */
  handleSubmit = async (e) => {
    e.preventDefault();

    const { postalCode } = this.state;
    const { wording, } = this.context;
    const { WLOST_232 } = wording;

    // Send GA event
    TagService.sendEvent(events.sendLetter);
    this.setState({ isFetching: true, isSubmitted: true });

    if (!postalCode) {
      this.setState({ error: WLOST_232 });
      this.postalInput.current.blur();
    } else {
      this.sendLetter();
    }
  };

  handleGoBack = () => {
    const { setStep } = this.context;

    setStep('/choice');
  }

  render() {
    const { isCheckingEligibility, isFetching, error, letterIsPending, letterIsSent } = this.state;
    const { wording } = this.context;
    const { WLOST_200, WLOST_230, WLOST_231, WLOST_236, WBUTTON_002, WBUTTON_004 } = wording;

    if (isCheckingEligibility) {
      return <Spinner />;
    }
    if (letterIsPending) {
      return <PendingLetter />;
    }
    if (letterIsSent) {
      return <LetterConfirm />;
    }

    return (
      <GridWrapper>
        <form onSubmit={this.handleSubmit} method="post">
          <GridRow>
            <GridColumn>
              <Heading as="h3" id="letter-subtitle" className="spacing-m">{WLOST_200}</Heading>
              <Text id="letter-message">
                {WLOST_230}
              </Text>
            </GridColumn>
          </GridRow>

          <GridRow>
            <GridColumn size={{ xs: 1, m: 8 / 12 }}>
              <Input
                autoFocus
                ref={this.postalInput}
                id="postal-code-input"
                error={error}
                onBlur={this.handleBlur}
                onChange={this.handleChange}
                label={WLOST_231}
                displayOptionalLabel={false}
                maxLength={2}
              />
            </GridColumn>
          </GridRow>

          <GridRow>
            <GridColumn size={{ xs: 1 }}>
              <Buttons className="spacing-xs">
                <ArrowLink
                  href=""
                  as={Link}
                  to="/choice"
                  onClick={this.handleGoBack}
                  id="back-to-canal"
                  aria-label={WBUTTON_004}
                  title={WBUTTON_004}
                  variant="previous"
                >
                  {WBUTTON_004}
                </ArrowLink>
                <Button type="submit" id="submit-postal-code" disabled={isFetching}>
                  {WBUTTON_002}
                </Button>
              </Buttons>
            </GridColumn>
          </GridRow>

          <GridRow>
            <GridColumn size={{ xs: 1 }}>
              <Alert id="sav-letter-message" mini variant="info" title={WLOST_236} className="spacing-s" />
            </GridColumn>
          </GridRow>

        </form>
      </GridWrapper>
    );
  }
}

LetterView.contextType = UserContext;

LetterView.defaultProps = {
};

LetterView.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withRouter(LetterView);